
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gJKhSoRdKuUJDXAGQCcQODtZmXWT7bldefucdJsKzArIMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexLGeiIpg8kVVr3h5_45IzPny5t1IELuS_2DJMcBNoHj3kMMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search0f_45aClaAOe5C4eoQ9w6UF0ubF8908YPVdFmHeAC9ROYMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexA81Jqvm4oC1O2g4SeJKRo62Zh8dCHaa_k_45eh9CBFTYcMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93mwE_45BO_45RdSGYae1hfv0E1XTw2oiHSVZZScNxJKZdL3EMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexaOyPoD6mIrdZ_Kj31c9qeYsYuLDHnya5Mog4T3Biu_kMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93mMCm5igHyRfHJjRSE_45Iv0C_45_45I8Y8zkr7pqfHRetT__YMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index1R3acFVER2UER_45tOpk2qNL97NDo8s6OP5mBxnRbaZ4QMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93EiIuk5cbCbE8JNELHF7IxBPHwnd3yoiBEw2o3vBymOwMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index6ZQGPqgCZ2EMITAco4KA_45HL3K2C9KcFcWjgKRKUW0xMMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexxPzvqrN6MwP_O5tvB0zxvdY7iC_bBSvF586HHwneooYMeta } from "/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexaOyPoD6mIrdZ_Kj31c9qeYsYuLDHnya5Mog4T3Biu_kMeta || {},
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index1R3acFVER2UER_45tOpk2qNL97NDo8s6OP5mBxnRbaZ4QMeta || {},
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index6ZQGPqgCZ2EMITAco4KA_45HL3K2C9KcFcWjgKRKUW0xMMeta || {},
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexxPzvqrN6MwP_O5tvB0zxvdY7iC_bBSvF586HHwneooYMeta || {},
    component: () => import("/codebuild/output/src1773393533/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]